import { render, staticRenderFns } from "./JourneyDetail.vue?vue&type=template&id=21f652af"
import script from "./JourneyDetail.vue?vue&type=script&lang=js"
export * from "./JourneyDetail.vue?vue&type=script&lang=js"
import style0 from "./JourneyDetail.vue?vue&type=style&index=0&id=21f652af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports